import { TS_OfferMoreEvent } from "../TravelSeller/Models/TS_OfferMoreEvent";
import { BookingItemInterface } from "./BookingItemInterface";

export class OfferMoreEvent extends TS_OfferMoreEvent implements BookingItemInterface {}
